import { render, staticRenderFns } from "./al-selector.vue?vue&type=template&id=0cb20c65"
import script from "./al-selector.vue?vue&type=script&lang=js"
export * from "./al-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports